export const DriverLicenseGroup = [
    {code:"M",coverage:[]},
    {code:"A1",coverage:["M"]},
    {code:"A2",coverage:["M","A1"]},
    {code:"A",coverage:["M","A1","A2"]},
    {code:"B1",coverage:["M"]},
    {code:"B",coverage:["M","B1","F"]},
    {code:"BE",coverage:["M","B","B1","F"]},
    {code:"C1",coverage:["M","B","B1","F"]},
    {code:"C1E",coverage:["M","B","BE","B1","C1","F"]},
    {code:"C",coverage:["M","B","B1","C1","F"]},
    {code:"CE",coverage:["M","B","BE","B1","C","C1","C1E","F"]},
    {code:"D1",coverage:["M","B","B1","F"]},
    {code:"D1E",coverage:["M","B","BE","B1","D1","F"]},
    {code:"D",coverage:["M","B","B1","D1","F"]},
    {code:"DE",coverage:["M","B","BE","B1","D","D1","D1E"]},
    {code:"F",coverage:["M"]},
    {code:"G",coverage:["M"]},
]